
"use strict";

module.exports = function (angular, app) {
    app.service("userLiveViewService", [
        "UserLiveViewDataProvider",
        function (UserLiveViewDataProvider) {
            return {
                stop: false,
                sequenceHandlersObject: {},
                startUserLiveViewDataFetchSequence: function (params) {
                    this.stop = false;

                    console.log('startUserLiveViewDataFetchSequence', params);

                    Object.keys(this.sequenceHandlersObject).forEach(hash => {
                        console.log('flush');

                        if (this.sequenceHandlersObject[hash]) {
                            clearTimeout(this.sequenceHandlersObject[hash]);
                        }
                    });

                    return new Promise((resolve) => {
                        let sequenceHash = "userLiveViewDataSequence|" + params.sessionId;

                        if (this.stop) {
                            return resolve();
                        }

                        var wrapTimeLoop = () => {
                            if (this.sequenceHandlersObject[sequenceHash]) {
                                clearTimeout(this.sequenceHandlersObject[sequenceHash]);
                            }

                            if (this.stop) {
                                return resolve();
                            }

                            UserLiveViewDataProvider.getUserLiveViewData(params.sessionId).then(response => {
                                console.log('respons', response);

                                if (this.stop) {
                                    return resolve();
                                }

                                if (response) {
                                    resolve();

                                    this.sequenceHandlersObject[sequenceHash] = setTimeout(() => {
                                        wrapTimeLoop()
                                    }, params.frequency);
                                } else {
                                    this.sequenceHandlersObject[sequenceHash] = setTimeout(() => {
                                        wrapTimeLoop()
                                    }, 2000);
                                }
                            }).catch(err => {
                                console.log("USER LIVE VIEW SERVICE: Error while executing UserLiveViewDataProvider.getUserLiveViewData", err);
                            });
                        };

                        wrapTimeLoop();
                    });
                },
                stopUserLiveViewDataFetchSequences() {
                    this.stop = true;

                    console.log('this.sequenceHandlersObject', this.sequenceHandlersObject)
                    Object.keys(this.sequenceHandlersObject).forEach(hash => {
                        console.log('flush');

                        if (this.sequenceHandlersObject[hash]) {
                            clearTimeout(this.sequenceHandlersObject[hash]);
                        }
                    });
                },
                isStopped() {
                    return this.stop;
                }
            }
        }
    ]);
};
